function d(r) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(r);
}
function n(r) {
  return d(decodeURIComponent(r));
}
function i(r) {
  if (n(r))
    return r;
  throw new Error(`Invalid email address: ${r}`);
}
function s(r) {
  return n(r) ? r : void 0;
}
export {
  n as isEmailAddress,
  d as isValidEmailAddress,
  i as toEmailAddressOrThrow,
  s as toEmailAddressOrUndefined
};
